namespace RedBullMOBILE360.AutomaticReports {
    export interface ReportPartRow {
        Id?: number;
        ReportId?: number;
        PartName?: string;
        PartTitle?: string;
        PartType?: Web.Modules.Common.ReportPartType;
        PartQuery?: string;
        IsAttachment?: number;
        ReportReportChannel?: number;
        ReportSubject?: string;
        ReportTemplate?: string;
        ReportSchedule?: string;
        ReportIsEnabled?: number;
        ReportRecipients?: string;
    }

    export namespace ReportPartRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PartName';
        export const localTextPrefix = 'AutomaticReports.ReportPart';
        export const deletePermission = 'Reports:Setup';
        export const insertPermission = 'Reports:Setup';
        export const readPermission = 'Reports:Setup';
        export const updatePermission = 'Reports:Setup';

        export declare const enum Fields {
            Id = "Id",
            ReportId = "ReportId",
            PartName = "PartName",
            PartTitle = "PartTitle",
            PartType = "PartType",
            PartQuery = "PartQuery",
            IsAttachment = "IsAttachment",
            ReportReportChannel = "ReportReportChannel",
            ReportSubject = "ReportSubject",
            ReportTemplate = "ReportTemplate",
            ReportSchedule = "ReportSchedule",
            ReportIsEnabled = "ReportIsEnabled",
            ReportRecipients = "ReportRecipients"
        }
    }
}
